import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-grids';
import { Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { GetCaregiverLogsBo } from './caregiver-logs.modal';
@Injectable({
  providedIn: 'root'
})
export class CaregiverLogsService extends Subject<DataStateChangeEventArgs> {
  constructor(private http: HttpClient, public errorService: ErrorService) {
    super();
  }

  GetErrorList(params: URLSearchParams): Observable<any> {
    let url = "api/EvvAggregatorTransactionLog/GetAggregatorCaregiverTransactionError?";
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  public outputlogs(tlogs): void {
    this.getCaregiverLogsList(tlogs).subscribe(x => super.next(x));
  }

  getCaregiverLogsList(tlogs: GetCaregiverLogsBo): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/EvvAggregatorTransactionLog/GetAggregatorCaregiverTransactionLog", tlogs)
      .pipe(map(
        (response: any) => (<any>{
          result: response['list'],
          count: response['totalCount'],
        }))).pipe(map((e: any) => {
          return e;
        })
        )
  }
}
